<template>
    <div class="stamp-exchange">
        <!-- 顶部标题栏 -->
        <div class="header">
            <img class="back" src="@/assets/common_back.png" alt="" @click="back"/>
            <span class="title">印花兑换</span>
        </div>

        <!-- 印花信息区 -->
        <div class="stamp-info-bar">
            <div class="info-item exchange-count-item">
                <span class="info-label">可兑换商品数：</span>
                <span class="info-value">{{ exchangeCount }}</span>
            </div>
            <div class="info-item stamp-balance-item">
                <span class="info-label">可用印花:</span>
                <span class="info-value highlight">{{ userStamps }}</span>
            </div>
        </div>

        <!-- 搜索框 -->
        <div class="search-bar">
            <div class="search-input-wrapper">
                <img class="search-icon" src="@/assets/search.png" alt=""/>
                <input
                    class="search-input"
                    placeholder="搜索商品..."
                    v-model="searchKeyword"
                    @input="onSearchInput"
                />
            </div>
        </div>

        <!-- 分类标签 -->
        <div class="category-scroll">
            <div class="category-list">
                <div
                    v-for="(item) in categories"
                    :key="item.id"
                    :class="['category-item', currentCategory === item.id ? 'active' : '']"
                    @click="onCategoryTap(item.id)"
                >
                    {{ item.name }}
                </div>
            </div>
        </div>

        <!-- 商品列表 -->
        <div class="goods-container">
            <div class="goods-grid">
                <div
                    v-for="item in goodsList"
                    :key="item.id"
                    class="goods-item"
                    @click="onExchangeTap(item.id)"
                >
                    <div class="goods-image-wrapper">
                        <img class="goods-image" :src="item.image" :alt="item.name" />
                        <div v-if="item.tag" :class="['goods-tag', item.tagClass]">{{ item.tag }}</div>
                    </div>
                    <div class="goods-info">
                        <span class="goods-name">{{ item.name }}</span>
                        <div class="goods-bottom">
                            <div class="stamp-price" v-if="item.isFirstExchange">
                                <span class="original-stamp">{{item.originalStamps}}印花</span>
                                <span class="discount-stamp">{{item.stamps}}印花</span>
                            </div>
                            <div class="goods-stamp" v-else>{{item.stamps}}印花</div>
                            <div class="exchange-btn">立即兑换</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Toast 提示 -->
        <Toast ref="toast"></Toast>
    </div>
</template>

<script>
import { GetExchangeGoodsList, ExchangeSearch, ExchangeGoodsType } from '../../api/StampShop'
import axios from '../../utils/axios'
import {BASE_URL} from "@/config/app";

export default {
    name: 'StampExchange',
    data() {
        return {
            userStamps: '',
            exchangeCount: '',
            searchKeyword: '',
            currentCategory: 0,
            categories: [{ id: 0, name: '全部商品' }],
            goodsList: []
        }
    },
    created() {
        this.loadData()
    },
    activated() {
        this.loadData()
    },
    methods: {
        // Toast 提示方法
        toast(e) {
            this.$refs.toast.show(e, 1500);
        },
        // 返回
        back() {
            this.$router.go(-1)
        },

        // 搜索输入
        onSearchInput() {
            this.getExchangeGoodsList(this.searchKeyword, this.currentCategory)
        },

        // 分类点击
        onCategoryTap(categoryId) {
            this.currentCategory = categoryId
            this.getExchangeGoodsList(this.searchKeyword, categoryId)
        },

        // 兑换商品点击
        onExchangeTap(id) {
            this.$router.push({
                path: '/stampExchangeDetail',
                query: {
                    id: id,
                    userStamps: this.userStamps
                }
            })
        },

        // 加载数据
        loadData() {
            this.getExchangeGoodsType()
            this.getExchangeSearch()
            this.getUserStamps()
            this.getExchangeGoodsList()
        },

        // 获取商品分类
        async getExchangeGoodsType() {
            try {
                const res = await ExchangeGoodsType({})

                if (res.code === this.$API_CODE.OK) {
                    const allCategory = [{ id: 0, name: '全部商品' }]
                    const backendCategories = res.data || []
                    this.categories = [...allCategory, ...backendCategories]
                }
            } catch (error) {
                console.error('获取商品分类失败:', error)
            }
        },

        // 获取可兑换商品数量
        async getExchangeSearch() {
            try {
                const res = await ExchangeSearch({})

                if (res.code === this.$API_CODE.OK) {
                    this.exchangeCount = `${res.data.qtyOfUse}/${res.data.qtyOfTotal}次`
                }
            } catch (error) {
                console.error('获取可兑换商品数量失败:', error)
            }
        },

        // 获取用户印花数量
        async getUserStamps() {
            try {
                const res = await axios({
                    url: '/stamp',
                    method: 'get',
                    params: {}
                })

                if (res.code === this.$API_CODE.OK) {
                    this.userStamps = res.data.stampQuantity
                }
            } catch (error) {
                console.error('获取用户印花数量失败:', error)
            }
        },

        // 获取兑换商品列表
        async getExchangeGoodsList(productName = '', productType = 0) {
            try {
                const params = { activityId: 1 }

                if (productName) {
                    params.productName = productName
                }

                if (productType) {
                    params.productType = productType
                }

                const res = await GetExchangeGoodsList(params)

                if (res.code === this.$API_CODE.OK) {
                    const exchangeGoodsList = []
                    res.data.forEach((item) => {
                        exchangeGoodsList.push({
                            id: item.id,
                            name: item.productname,
                            stamps: item.stampQuantity,
                            isFirstExchange: item.isFirstExchange,
                            originalStamps: item.originalStampQuantity,
                            image: BASE_URL + item.imgurl,
                            tag: item.tag === 1 ? '热门' : item.tag === 2 ? '新品' : '',
                            tagClass: item.tag === 1 ? 'hot' : item.tag === 2 ? 'new' : ''
                        })
                    })
                    this.goodsList = exchangeGoodsList
                } else {
                    this.toast(res.message || '获取商品列表失败')
                }
            } catch (error) {
                console.error('获取兑换商品列表失败:', error)
                this.toast('获取商品列表失败')
            }
        }
    }
}
</script>

<style scoped lang="scss">
.stamp-exchange {
    background-color: #f5f5f5;
    min-height: 100vh;
    padding-bottom: 10px;
}

/* 顶部标题栏 */
.header {
    height: 45px;
    line-height: 45px;
    background-color: #ed3f14;
    padding: 0 10px;
    position: relative;
}

.back {
    width: 16px;
    height: 16px;
    float: left;
    margin-top: 15px;
    margin-right: 10px;
    cursor: pointer;
}

.title {
    color: white;
    font-size: 18px;
    font-weight: 500;
}

/* 印花信息区 */
.stamp-info-bar {
    background-color: #fff;
    padding: 12px 15px;
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 10px 10px 8px;
    border-radius: 8px;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
}

.info-item {
    background-color: #f0f8f0;
    padding: 8px 14px;
    border-radius: 12px;
    display: flex;
    align-items: center;
}

.info-label {
    font-size: 13px;
    color: #666;
    margin-right: 4px;
}

.info-value {
    font-size: 14px;
    color: #4caf50;
    font-weight: 500;
}

.info-value.highlight {
    color: #ff4757;
    font-weight: bold;
    font-size: 16px;
}

/* 搜索框 */
.search-bar {
    padding: 0 10px;
    margin-bottom: 8px;
}

.search-input-wrapper {
    background-color: #fff;
    border-radius: 20px;
    padding: 8px 15px;
    display: flex;
    align-items: center;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
}

.search-icon {
    width: 16px;
    height: 16px;
    margin-right: 8px;
    opacity: 0.5;
}

.search-input {
    flex: 1;
    font-size: 14px;
    color: #333;
    border: none;
    outline: none;
    background: transparent;

    &::placeholder {
        color: #999;
    }
}

/* 分类标签 */
.category-scroll {
    background-color: #fff;
    padding: 10px 0;
    margin-bottom: 8px;
    overflow-x: auto;
    white-space: nowrap;

    &::-webkit-scrollbar {
        display: none;
    }
}

.category-list {
    display: inline-flex;
    padding: 0 10px;
    gap: 8px;
}

.category-item {
    background-color: #f5f5f5;
    color: #666;
    font-size: 14px;
    padding: 7px 16px;
    border-radius: 16px;
    white-space: nowrap;
    transition: all 0.3s;
    cursor: pointer;

    &:hover {
        opacity: 0.8;
    }
}

.category-item.active {
    background: linear-gradient(135deg, #4caf50, #45a049);
    color: #fff;
    font-weight: 500;
    box-shadow: 0 2px 6px rgba(76, 175, 80, 0.3);
}

/* 商品列表 */
.goods-container {
    background: #fff;
    margin: 10px;
    border-radius: 10px;
    padding: 5px;
}

.goods-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
}

.goods-item {
    background: #fff;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
    transition: all 0.3s;
    cursor: pointer;

    &:active {
        transform: scale(0.98);
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
    }
}

.goods-image-wrapper {
    position: relative;
    width: 100%;
    height: 165px;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.goods-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.goods-tag {
    position: absolute;
    top: 8px;
    left: 8px;
    background: linear-gradient(135deg, #ff6b6b, #ff4757);
    color: #fff;
    font-size: 11px;
    padding: 4px 10px;
    border-radius: 10px;
    font-weight: 500;
    box-shadow: 0 2px 6px rgba(255, 71, 87, 0.3);
}

.goods-tag.hot {
    background: linear-gradient(135deg, #ff5722, #ff5722);
}

.goods-tag.new {
    background: linear-gradient(135deg, #ff6b6b, #ff4757);
}

.goods-info {
    padding: 12px;
}

.goods-name {
    text-align: left;
    display: block;
    font-size: 14px;
    color: #333;
    margin-bottom: 10px;
    line-height: 1.5;
    height: 42px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    font-weight: 500;
}

.goods-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.goods-stamp {
    font-size: 16px;
    color: #ff4757;
    font-weight: bold;
}

.stamp-price {
  display: flex;
  flex-direction: column;
}

.original-stamp {
  font-size: 12px;
  color: #999;
  text-decoration: line-through;
}

.discount-stamp {
  font-size: 16px;
  color: #ff4757;
  font-weight: bold;
}

.exchange-btn {
    background: linear-gradient(135deg, #ea2d53, #ea2d53);
    color: #fff;
    font-size: 12px;
    padding: 6px 14px;
    border-radius: 15px;
    font-weight: 500;
    box-shadow: 0 2px 6px rgba(76, 175, 80, 0.3);
}
</style>
